const normalizePovValue = (value) => String(value ?? '').trim();
const normalizePovRole = (value) => normalizePovValue(value).toUpperCase();

export const getAnalysisPov = (metadata = {}) => ({
    party_role: normalizePovRole(metadata?.party_role) || null,
    studied_party_name: normalizePovValue(metadata?.studied_party_name) || null,
});

export const hasCompletePov = (metadata = {}) => {
    const pov = getAnalysisPov(metadata);
    return Boolean(pov.party_role && pov.studied_party_name);
};

export const isSamePov = (left = {}, right = {}) => {
    const leftPov = getAnalysisPov(left);
    const rightPov = getAnalysisPov(right);
    return leftPov.party_role === rightPov.party_role
        && leftPov.studied_party_name === rightPov.studied_party_name;
};
